var _defs, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusSuccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "c",
    "data-name": "design",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 41.49 41.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    "data-name": "\\u540D\\u79F0\\u672A\\u8A2D\\u5B9A\\u30B0\\u30E9\\u30C7\\u30FC\\u30B7\\u30E7\\u30F3 1126",
    x1: 22.66,
    y1: 31.41,
    x2: 18.84,
    y2: 9.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a8a8d4"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.75,
    cy: 20.59,
    r: 7.99,
    fill: "none",
    stroke: "url(#d)",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.75,
    cy: 20.59,
    r: 7.99,
    fill: "#c8ff00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusSuccessIcon);
export default __webpack_public_path__ + "static/media/status-success-icon.003e9d7e4eeef43e63c3394f1bb8b77f.svg";
export { ForwardRef as ReactComponent };